import React from 'react';

const ProductSkeleton = () => {
  return (
    <div className="products-container container animate-pulse">
      {[...Array(4)].map((_, i) => {
        return (
          <article
            className="flex gap-2 h-[520px] w-full hover:bg-slate-50 transition-all"
            key={i}
          >
            <div className="min-h-full min-w-[50%] max-w-[50%] object-contain bg-slate-400" />
            <div className="px-2 py-4 overflow-auto flex flex-col gap-4 w-full">
              <span className="bg-slate-400 w-[50%] h-10 rounded-xl" />
              <span className="bg-slate-400 w-full h-5 rounded-xl" />
              <span className="bg-slate-400 w-[calc(100%-40px)] h-5 rounded-xl" />
              <span className="bg-slate-400 w-[calc(100%-20px)] h-5 rounded-xl" />
              <span className="bg-slate-400 w-[70%] h-5 rounded-xl" />
              <span className="bg-slate-400 w-[50%] h-7 rounded-xl mt-4" />
              <span className="bg-slate-400 w-[70%] h-5 rounded-xl" />
            </div>
          </article>
        );
      })}
    </div>
  );
};

export default ProductSkeleton;
